import { render, staticRenderFns } from "./SummaryRecordSlidder.vue?vue&type=template&id=4668a3c9&scoped=true"
import script from "./SummaryRecordSlidder.vue?vue&type=script&lang=js"
export * from "./SummaryRecordSlidder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4668a3c9",
  null
  
)

export default component.exports